import React from 'react';
import { MultiDropzone as DefaultMultiDropzone } from './styled';
import { FormHelperText } from '../../../form-helper-text';
import { Title } from '../../components/title';
import { Caption } from '../../components/caption';
import { FilesList } from '../../components/files-list';
export const MultiUploader = (props) => {
    const { dropzone, files, maxSize, onAttach, onRemoveFile, onAbort, onDownload, onPreview, rootProps, inputProps, title, caption, hint, hintType, fixedPadding } = props;
    const Dropzone = dropzone !== null && dropzone !== void 0 ? dropzone : DefaultMultiDropzone;
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropzone, { ...rootProps, "data-testid": "file-uploader-dropzone" },
            React.createElement("input", { ...inputProps }),
            React.createElement(Title, { title: title, isSingle: false }),
            React.createElement(Caption, { caption: caption, maxSize: maxSize })),
        React.createElement(FormHelperText, { fixedPadding: fixedPadding, msgType: hintType }, hint),
        React.createElement(FilesList, { "data-testid": "file-uploader-files-section", files: files, maxSize: maxSize, onAttach: onAttach, onRemoveFile: onRemoveFile, onAbort: onAbort, onDownload: onDownload, onPreview: onPreview, disabled: rootProps.disabled })));
};
